import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CardholderIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M4.999 20a6.019 6.019 0 016-6H13a6.019 6.019 0 016.001 6zm2.6-2h8.902a4.034 4.034 0 00-3.5-2H11.1a4.036 4.036 0 00-3.5 2zM8 9V8a4 4 0 018.002 0v1a4 4 0 11-8.002 0zm2-1v1A2 2 0 1014 9V8a2 2 0 00-4 0z" />
  </SvgIcon>
);
CardholderIcon.displayName = 'CardholderIcon';
CardholderIcon.muiName = 'SvgIcon';

export default CardholderIcon;
